import useBanners from './banners';
import useCatalog from './catalog';
import useCheckout from './checkout';
import useFavorites from './favorites';
import usePage from './page';
import useProduct from './product';
import useSearch from './search';
import useUser from './user';

/**
 * Плагин для отправки событий в PersGate
 * События отправляются через BFF API
 */
export default {
  install: (app, options) => {
    const { store, router } = options;

    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$persEvents = {

      ...useProduct({
        adaptive: options.adaptive,
        store,
        router,
      }),

      ...useBanners({
        store,
        router,
      }),

      ...useCheckout({
        store,
        router,
      }),

      ...usePage({
        store,
        router,
      }),

      ...useSearch({
        adaptive: options.adaptive,
        store,
        router,
      }),

      ...useCatalog({
        adaptive: options.adaptive,
        store,
        router,
      }),

      ...useUser({
        store,
        router,
      }),

      ...useFavorites({
        store,
        router,
      }),
    };
  },
};
